export default __webpack_public_path__ + "static/media/kitchen4.67eafc34.webp";